module.exports = __webpack_public_path__ + "static/media/rainbowball.c6ffbf17.svg";